import React from "react";

const B2BNav = () => {
  return (
    <nav className="b2b-nav">
      <div className="b2b-nav-inner-simple">
        <a href="/" className="b2b-logo">
          <div className="b2b-logo-container">
            <div className="b2b-logo-mark">
              <div className="logo-text-top">THE</div>
              <div className="logo-divider"></div>
              <div className="logo-text-main">
                <span className="text-local">LOCAL</span>
                <span className="text-intent">INTENT</span>
              </div>
              <div className="logo-divider"></div>
              <div className="logo-text-bottom">COMPANY</div>
            </div>
          </div>
        </a>
      </div>
    </nav>
  );
};

export default B2BNav;
